import './ChangePassword.scss'

import React, {Component} from 'react'
import { Button, Input } from 'react-bootstrap'
import Alert from 'common/views/atoms/Alert/Alert'

import { changePassword } from 'common/redux/auth'
import { loadError } from 'common/redux/root'

class ChangePassword extends Component {

    constructor(props) {
      super(props)
      this.state = {
        password: '',
        password_2: '',
        done: false,
        error: '',
      }
      this.handleSubmit = this.handleSubmit.bind(this)
      this.validate = this.validate.bind(this)
    }

    validate() {
      if (this.state.password != this.state.password_2) {
        this.setState({error: "Passwords do not match"})
        return false
      }
      if (this.state.password.length < 6) {
        this.setState({error: "Password must be at least 6 characters"})
        return false
      }
      this.setState({error: null})
      return true
    }

    handleSubmit(e) {
        e.preventDefault()

        if (!this.validate()) {
          this.setState({

          })
          return
        }

        this.props.dispatch(changePassword(this.props.params.hash, this.state.password)).then(() => {
          this.setState({done: true})
        }).catch(error => window.location.reload())
    }

    render() {
      const form = <div className='login-inner'>
        <Input type="password" label="New Password" value={this.state.password} onChange={(e) => this.setState(...this.state, {password:e.target.value})} />
        <Input type="password" label="Retype New Password" value={this.state.password_2} onChange={(e) => this.setState(...this.state, {password_2:e.target.value})} />
        <Button bsStyle="primary" type="submit">{ this.props.create ? 'Create Account' : 'Change Password' }</Button>
      </div>

      const success = <div className="ChangePassword__notice ChangePassword__notice--success">
        <i className="fa fa-check-circle" aria-hidden="true"></i>
        <div>Your password was { this.props.create ? 'set' : 'changed' } successfully.</div>
        <div><a href="/login">Login Now</a></div>
      </div>

      const notFound = <div className="ChangePassword__notice ChangePassword__notice--error">
        <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
        <div>{ this.props.create ? 'This link has expired.' : 'This password reset link has expired.' }</div>
        <div>Please submit a support request on our <a href="https://support.realtor.com/s/contactsupport" target="_blank" rel="noopener noreferrer">Support Portal</a>.</div>
      </div>

      return (
        <div className='ChangePassword'>
          <form onSubmit={this.handleSubmit}>
              <div className="ChangePassword__title"><img src="https://s3.amazonaws.com/opcity-email-assets/opcity_icon_logo.png" height={60}/></div>
              <div className="ChangePassword__subtitle">{ this.props.create ? 'Create Account' : 'Reset Password' }</div>
              <div>
                <Alert type="danger" errorText={this.state.error ? this.state.error : ""} />
              </div>
              { this.props.params.hash === 'not-found' ? notFound : !this.state.done ? form : success}
          </form>
        </div>
      )
    }
}

export default ChangePassword
